import { useRequestOrgStudioList } from '~/requests';

export const useRequestOrgStudioListWithStatus = (defaultQuery: { [name: string]: any }) => {
  const orgListQuery = useRequestOrgStudioList(defaultQuery);
  return orgListQuery;
};
